import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './MemberLayout.module.scss';

const MemberLayout: React.FC = () => {
    const { user, isAdmin, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className={styles.layout}>
            <aside className={styles.sidebar}>
                <div className={styles.logo}>
                    <Link to="/dashboard">Labuzi Poker Club</Link>
                </div>
                <nav className={styles.nav}>
                    <Link to="/dashboard">Dashboard</Link>
                    <Link to="/profile">Profil</Link>
                    {isAdmin && <Link to="/admin/members">Gestion Membres</Link>}
                </nav>
                <div className={styles.userInfo}>
                    <span>{user?.firstname} {user?.lastname}</span>
                    <button onClick={handleLogout} className={styles.logoutBtn}>
                        Déconnexion
                    </button>
                </div>
            </aside>
            <main className={styles.content}>
                <Outlet />
            </main>
        </div>
    );
};

export default MemberLayout;
